"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var menu_items_1 = __importDefault(require("./menu_items"));
var selected_items_configuration_1 = __importDefault(require("./selected_items_configuration"));
var react_1 = require("@nextui-org/react");
var react_router_dom_1 = require("react-router-dom");
function ProductConfiguration(_a) {
    var step = _a.step, goToStep = _a.goToStep;
    var menu_concept_id = (0, react_router_dom_1.useParams)().menu_concept_id;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "w-[40%]" }, { children: (0, jsx_runtime_1.jsx)(menu_items_1.default, { menu_concept_id: menu_concept_id }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "w-[60%]" }, { children: (0, jsx_runtime_1.jsx)(selected_items_configuration_1.default, {}) }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, __assign({ onClick: function () {
                            goToStep(step - 1);
                        } }, { children: "Back" })), (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ color: "primary", onClick: function () {
                            goToStep(step + 1);
                        } }, { children: "Save & Continue" }))] }))] })));
}
exports.default = ProductConfiguration;
